import React from 'react';
import {Header} from 'semantic-ui-react';

import {ClientApiKeyDeleteMutation, ClientApiKeyDisableMutation} from '@graphql/clientAvApiKey/mutation';
import {convertToInt, isUrlParamValid} from '@utils/helpers';
import {refetchQueryByName} from '@utils/apollo';
import {hideModal, showModal, showModalConfirmation} from '@utils/modal';
import {renderModalError} from '@utils/forms';
import {getLink} from '@appComponents/Link';
import ClientAvApiKeyModalContent from '@modules/client/forms/ClientAvApiKeyModalContent';
import {routes} from '@constants/routes';
import {showPopupMessage} from '@utils/popupMessage/PopupMessageService';

import apolloClient from '../../../apolloClient';

export const editClick = (row) => {
    let header = <Header content='Disable API key'/>,
        onYes = disableApiKey,
        text = 'Are you sure you want to disable this API key?';

    if (row.is_disabled) {
        header = <Header content='Remove API key'/>;
        onYes = removeApiKey;
        text = 'Are you sure you want to remove this API key?';
    }

    showModalConfirmation({
        header,
        onYes: row ? () => onYes(row) : onYes,
        text,
    });
};

export const disableApiKey = (row) => {
    showModalConfirmation({text: 'Disabling the API key...'});

    return apolloClient.mutate({
        mutation: ClientApiKeyDisableMutation,
        variables: {
            id: convertToInt(row.id),
        },
    }).then(({data}) => {
        if (null === data?.disableClientApiKey?.is_disabled) {
            showPopupMessage(
                'The API key could not be disabled.',
                'error'
            );

            hideModal();
        } else {
            showPopupMessage(
                'The API key has been disabled successfully.',
                'success'
            );

            hideModal();
        }
        refetchQueryByName('ClientApiKeysQuery');
    }).catch(error => {
        showPopupMessage(
            'The API key could not be disabled.',
            'error',
            true,
            `${error}`
        );
    });
};

export const removeApiKey = (row) => {
    showModalConfirmation({text: 'Removing the API key...'});

    return apolloClient.mutate({
        mutation: ClientApiKeyDeleteMutation,
        variables: {
            id: convertToInt(row.id),
        },
    }).then(() => {
        showPopupMessage(
            'The API key has been removed successfully.',
            'success'
        );

        hideModal();
        refetchQueryByName('ClientApiKeysQuery');
    }).catch((error) => {
        showPopupMessage(
            'The API key could not be removed.',
            'error',
            true,
            `${error}`
        );
    });
};

export const loadModal = (bookmaker, match) => {
    const clientId = convertToInt(match.params.id);
    const clientApiKeyId = match.params.clientApiKeyId
        ? convertToInt(match.params.clientApiKeyId)
        : null;
    const bookmakerId = convertToInt(bookmaker?.id);

    if (match.path === routes.clients.apiKey.add.path) {
        if (!bookmaker) {
            return showModal({
                isVisible: true,
                content: renderModalError(
                    null,
                    getLink('clients.apiKey.index', {id: clientId}),
                    <p>This client has no Bookmaker ID. API key generation is not possible without Bookmaker ID.</p>
                ),
            });
        }

        return showModal({
            size: 'large',
            header: null,
            isVisible: true,
            content: (
                <ClientAvApiKeyModalContent
                    clientId={clientId}
                    bookmakerId={bookmakerId}
                    clientApiKeyId={clientApiKeyId}
                    isAddForm={true}
                />
            ),
        });
    }

    if (match.path === routes.clients.apiKey.edit.path) {
        if (!isUrlParamValid(clientApiKeyId)) {
            return showModal({
                isVisible: true,
                content: renderModalError('API key', getLink('clients.apiKey.index', {id: clientId})),
            });
        }

        return showModal({
            size: 'large',
            header: null,
            isVisible: true,
            content: (
                <ClientAvApiKeyModalContent
                    clientId={clientId}
                    bookmakerId={bookmakerId}
                    clientApiKeyId={clientApiKeyId}
                />
            ),
        });
    }
};
